import React, { useState, useEffect } from "react";

import franchisee_img from "../images/franchisee img.jpeg";



export default function AutoPopup() {

  const [open, setOpen] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setOpen(true);
    }, 1500);

    return () => clearTimeout(timer);
  }, []);

  const closePopup = () => setOpen(false);

  return (
    <>
      {open && (
        <div className="popup-overlay">

          <div className="popup-box">

            {/* Close Icon */}
            <span className="popup-close" onClick={closePopup}>
              ×
            </span>

            <div className="popup-content">

 <a href="tel: 7031820115">
                <img src={franchisee_img} className="card-img-top mb-0" alt="franchisee" />
</a>

              <button className="popup-btn" onClick={closePopup}>
                Close
              </button>

            </div>

          </div>

        </div>
      )}
    </>
  );
}